import React from 'react';

import SupportRequestPresenter from '../../../../../../presenters/SupportRequestPresenter';
import Group from '../../../../../../components/Group';
import Row from '../../../../../../components/Row';
import Column from '../../../../../../components/Column';
import Value from '../../../../../../components/Value';

const RequestInfo = (props) => {
  const { request } = props;

  return (
    <Group title="Request Info">
      <Row>
        <Column>
          <Value attr="requestReceived" title="Recieved On">
            {SupportRequestPresenter.createdAt(request)}
          </Value>
        </Column>
        <Column>
          <Value attr="state" title="Status">
            {SupportRequestPresenter.state(request)}
          </Value>
        </Column>
        <Column></Column>
      </Row>
    </Group>
  );
};

export default RequestInfo;

RequestInfo.propTypes = {
  request: SupportRequestPresenter.shape().isRequired,
};
